import Avatar from 'components/base/Avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { plantillasWhatsapp } from 'data/chat';
import Button from 'components/base/Button';
import { useChatWidgetContext } from 'providers/ChatWidgetProvider';
import Message from 'components/modules/chat/message';
import { useEffect, useRef, useState } from 'react';
import { formatCelular } from 'services/chatService';
import axios from 'axios';
import { useAuth } from 'providers/AuthProvider';
import { is24hWindowOpen } from 'services/chatService';

const ChatWidgetConversation = () => {
  const { conversation, sentMessage } = useChatWidgetContext();
  const messageEndRef = useRef<null | HTMLSpanElement>(null);
  const API_URL = process.env.REACT_APP_API_URL;
  const { user } = useAuth();
  const miemValue = user?.iniciales || 'Sistema';
  const windowOpen = is24hWindowOpen(conversation.messages);

  // Un estado para evitar que el usuario haga doble clic rápido
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    messageEndRef.current?.scrollIntoView();
  }, [conversation]);

  const celular: string = formatCelular(conversation.user.celular ?? '');

  // 👇 NUEVA LÓGICA DE ENVÍO DE PLANTILLA 👇
  const handleSendTemplate = async (mensajeLabel: string) => {
    if (isSending) return;
    setIsSending(true);

    // Mapeamos el texto del botón al nombre interno de la plantilla en Meta
    let nombrePlantilla = 'novedades'; 

    if (mensajeLabel === 'Aviso de Novedades') {
      nombrePlantilla = 'novedades'; 
    }

    if (mensajeLabel === 'Vamos a Archivar Carpeta, quedó conforme?') {
      nombrePlantilla = 'feedback_survey_2'; 
    }

    if (mensajeLabel === 'i1 caso nuevo, no tenemos poder, no vino mas') {
      nombrePlantilla = 'i1'; 
    }

    if (mensajeLabel === 'Caso Nuevo, falta completar carpeta') {
      nombrePlantilla = 'completar_carpeta'; 
    }

    try {
      // 1. Disparamos la petición a nuestro backend
      await axios.post(`${API_URL}/whatsapps/send-template`, {
        celular: conversation.user.celular, // Usamos el número crudo sin formato
        nombrePlantilla: nombrePlantilla,
        idiomaCodigo: 'es_AR' // Ojo: pon 'es' o 'es_AR' según lo aprobasaste en Meta
      });

      // 2. Si Meta lo acepta, lo mostramos en nuestra pantalla
      sentMessage({ message: `[Plantilla enviada: ${mensajeLabel}]` });

    } catch (error) {
      console.error("❌ Error enviando plantilla:", error);
      alert("Hubo un error al enviar la plantilla. Revisa la consola.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
       <div className="text-center mt-auto">
        <h5 className="mt-2 mb-3">{conversation.user.name}</h5>
        <h5 className="mt-2 mb-3">{celular}</h5>
      </div> 

{/* 👇 NUEVO: ALERTA Y PLANTILLAS SI PASARON 24HS 👇 */}
      {!windowOpen && (
        <div className="px-3 mt-4">
          <div className="alert alert-warning text-center fs-9 py-2 mb-3">
            <strong>Atención:</strong> Esta conversación no tiene mensajes entrantes en las últimas 24 horas. Solo se puede contactar al cliente enviando una plantilla.
          </div>

          <div className="text-end">
            {plantillasWhatsapp.map((message, index) => (
              <Button
                key={message}
                onClick={() => handleSendTemplate(message)}
                disabled={isSending}
                className={classNames(
                'd-inline-flex align-items-center text-body-emphasis bg-body-hover rounded-pill border border-primary py-2 ps-4 pe-3 lh-base',
                { 'mb-2': index !== plantillasWhatsapp.length - 1 }
              )}
              >
                {/* ... tu renderizado del botón ... */}
              </Button>
            ))}
          </div>
        </div>
      )}

      {!conversation.messages.length && (
        <div className="text-end mt-6">
          {plantillasWhatsapp.map((message, index) => (
            <Button
              key={message}
              onClick={() => handleSendTemplate(message)} // 🚀 AHORA LLAMA A NUESTRA FUNCIÓN
              disabled={isSending}
              className={classNames(
                'd-inline-flex align-items-center text-body-emphasis bg-body-hover rounded-pill border border-primary py-2 ps-4 pe-3 lh-base',
                { 'mb-2': index !== plantillasWhatsapp.length - 1 }
              )}
            >
              <p className="mb-0 fw-semibold fs-9">
                {isSending ? 'Enviando...' : message}
              </p>
              <FontAwesomeIcon
                icon={faPaperPlane}
                className="text-primary fs-9 ms-3"
              />
            </Button>
          ))}
        </div>
      )}
      {conversation.messages.length > 0 && (
        <>
          <hr className="my-4 border-dashed border-top" />
          <div className="d-flex flex-column gap-2">
            {conversation.messages.map(message => (
              <Message
                message={message}
                user={conversation.user}
                key={message.id}
                showActions={false}
              />
            ))}
            <span ref={messageEndRef} />
          </div>
        </>
      )}
    </>
  );
};

export default ChatWidgetConversation;